import { Material } from "../../../../data/entities";
import StockCardModal from "../../../../shared/components/StockCardModal";

interface MaterialStockCardModalProps {
    open: boolean;
    onClose: () => void;
}

const MaterialStockCardModal = ({ open, onClose }: MaterialStockCardModalProps) => (
    <StockCardModal<Material>
        open={open}
        onClose={onClose}
        itemLabel="vật tư"
        itemLabelPlural="vật tư"
        itemListUrl="/materials/"
        stockCardUrl="/materials/stock-card/"
        itemIdsPayloadKey="material_ids"
        getItemCode={(material) => material.material_code}
    />
);

export default MaterialStockCardModal;
